import React from 'react';
import { motion } from 'framer-motion';
export function BookMockup() {
  return <motion.div className="relative w-full max-w-[360px] mx-auto" initial={{
    opacity: 0,
    y: 30
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.9,
    ease: 'easeOut'
  }} data-id="element-46">
      {/* Gold glow behind the book */}
      <div className="absolute inset-0 -z-10 blur-3xl" data-id="element-47">
        <div className="absolute top-1/4 left-1/4 w-3/4 h-3/4 bg-primary/25 rounded-full" data-id="element-48"></div>
        <div className="absolute bottom-1/4 right-1/4 w-1/2 h-1/2 bg-primary/15 rounded-full" data-id="element-49"></div>
      </div>

      <motion.img src="https://cdn.magicpatterns.com/uploads/gzJDNvMmvS1fxufX7HJCa3/Untitled_design.png" alt="Chef de Yates Internacionales - Ebook" className="w-full h-auto drop-shadow-[0_25px_50px_rgba(0,0,0,0.5)]" animate={{
      y: [0, -8, 0]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-50" />
    </motion.div>;
}